import {createSelector} from '@reduxjs/toolkit';

import {COMPARE_TYPES} from '@explorer/constants';

const getResultsById = state => state.results.resultsById;
const getMosaicsBySeries = state => state.mosaics.bySeries;
const selectCompareSubjects = state => state.compare.subjects;

export const getFullCompareSubjects = createSelector(
  [selectCompareSubjects, getResultsById, getMosaicsBySeries],
  (subjects, resultsById, mosaicsBySeries) => {
    const newSubjects = {...subjects};
    // This is only needed to hydrate the subject when coming from a shared state.
    Object.entries(subjects).forEach(([index, subject]) => {
      if (subject && !subject.item) {
        if (subject.type === COMPARE_TYPES.RESULT) {
          const result = resultsById[subject.id];
          newSubjects[index] = result
            ? {
                ...subject,
                item: result,
              }
            : null;
        } else if (subject.type === COMPARE_TYPES.SCENE) {
          const result = resultsById[subject.parent];
          if (result) {
            const item = result.properties.items.find(
              item => item.id === subject.id
            );
            newSubjects[index] = item
              ? {
                  ...subject,
                  item: {
                    ...item,
                    properties: {
                      ...item.properties,
                      items: [item],
                    },
                  },
                }
              : null;
          } else {
            newSubjects[index] = null;
          }
        } else if (subject.type === COMPARE_TYPES.MOSAIC) {
          let mosaic = null;
          if (mosaicsBySeries && mosaicsBySeries[subject.parent]) {
            mosaic = mosaicsBySeries[subject.parent].find(
              m => m.id === subject.id
            );
          }

          newSubjects[index] = mosaic
            ? {
                ...mosaic,
                ...subject,
              }
            : null;
        }
      }
    });

    return newSubjects;
  }
);

export const getCompareSubjectsLight = createSelector(
  [state => state.compare.subjects],
  subjects => {
    const newSubjects = {
      0: null,
      1: null,
    };
    Object.entries(subjects).forEach(([index, subject]) => {
      if (subject) {
        const ns = {...subject};
        if ('item' in ns) {
          delete ns.item;
        }
        newSubjects[index] = ns;
      }
    });
    return newSubjects;
  }
);
